export default "__VITE_ASSET__SOTr2TV9__"